import { Typography } from "antd";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRecoilValue } from "recoil";
import Api from "../API/api";
import { loginState, WHState } from "../Atom/AtomState";
import AlertComponent from "../CommonComponent/Alert/AlertComponent";
import ButtonComponent from "../CommonComponent/Inputs/ButtonComponent";
import TextComponent from "../CommonComponent/Inputs/TextComponent";
import Loading from "../CommonComponent/LoadingBar/Loading";
import TableComponent from "../CommonComponent/Tables/TableComponent";
import "../CSS/PageCSS/Questionpage.css";

const { Title } = Typography;

export default function QuestionPage() {
  let navigate = useNavigate();
  const WH = useRecoilValue(WHState);
  const LoginState = useRecoilValue(loginState);
  const [divboxHeight, setdivBoxHeight] = useState<number>(0);
  const [searchInformation, setSearchInformation] = useState({
    title: "",
  });
  const [questionData, setQuestionData] = useState<any>();
  const [alert, setAlert] = useState(false);
  const [alertMessage, setAlertMessage] = useState("");
  const [loading, setLoading] = useState(false);

  const changeTextField = (value: any) => {
    if (value.name == "title") {
      setSearchInformation((prev) => ({
        ...prev,
        title: value.value,
      }));
    }
  };

  const handleSearch = () => {
    const getSearch = async () => {
      setLoading(true);
      const question = await Api.get(
        `/Question/getQuestionSearch?question=${searchInformation.title}`
      );
      setLoading(false);
      if (question != undefined) {
        setQuestionData(question);
      } else {
        setAlert(true);
        setAlertMessage("데이터 조회에 실패하였습니다.");
      }
    };
    getSearch();
  };

  const handleRegister = () => {
    navigate("/QuestionDetailPage", {
      state: { state: "register" },
    });
  };

  const reorderRows = (e: any) => {
    let array: any = [];
    for (var i = 0; i < e.length; i++) {
      const newItem = {
        ...e[i],
        sort_order: i + 1,
      };
      array.push(newItem);
    }

    const getUpdate = async () => {
      const formData = new FormData();
      formData.append(
        "p_id",
        array.map((item: any) => item.p_id)
      );
      formData.append(
        "sort_order",
        array.map((item: any) => item.sort_order)
      );
      setLoading(true);
      const updateData = await Api.put(
        `/Question/updateSortOrderQuestion`,
        formData
      );
      setLoading(false);
      if (updateData != undefined) {
        const getData = async () => {
          setLoading(true);
          const question = await Api.get("/Question/getAllQuestionList");
          setLoading(false);
          if (question != undefined) {
            setQuestionData(question);
          } else {
            setAlert(true);
            setAlertMessage("데이터 조회에 실패하였습니다.");
          }
        };
        getData();
      } else {
        setAlert(true);
        setAlertMessage("질문 순서 수정에 실패하였습니다.");
      }
    };
    getUpdate();
  };

  useEffect(() => {
    if (!LoginState?.manager) {
      navigate("/");
    } else {
      const getData = async () => {
        setLoading(true);
        const question = await Api.get("/Question/getAllQuestionList");
        setLoading(false);
        if (question != undefined) {
          setQuestionData(question);
        } else {
          setAlert(true);
          setAlertMessage("데이터 조회에 실패하였습니다.");
        }
      };
      getData();
    }
  }, []);

  useEffect(() => {
    const handleResize = () => {
      const div = document.getElementById("divbox") as HTMLElement;
      const QuestionsearchTextDiv = document.getElementById(
        "QuestionsearchTextDiv"
      ) as HTMLElement;
      if (div && QuestionsearchTextDiv) {
        setdivBoxHeight(
          div.clientHeight - QuestionsearchTextDiv.clientHeight - 20
        );
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  });

  return (
    <div style={{ height: WH.height - 160 }}>
      <Title level={2} className="QuestionTitle">
        QuestionPage
      </Title>
      <div id="divbox">
        <div className="QuestionsearchTextDiv" id="QuestionsearchTextDiv">
          <TextComponent
            variant="filled"
            value={searchInformation.title}
            label="질문"
            name="title"
            placeholder="검색어를 입력해주세요."
            onChange={changeTextField}
            className="QuestionSearch"
          />
          <ButtonComponent
            fullWidth
            variant="contained"
            className="QuestionsearchTextDiv_searchButton"
            onClick={handleSearch}
          >
            검색
          </ButtonComponent>
          <ButtonComponent
            fullWidth
            variant="contained"
            onClick={handleRegister}
          >
            등록
          </ButtonComponent>
        </div>
        <TableComponent
          data={questionData}
          columns={[
            {
              width: "700px",
              header: "질문",
              field: "question",
            },
            {
              width: "100px",
              header: "조회여부",
              field: "show_yn",
              position: "center",
              type: "CheckBoxReadOnly",
            },
            {
              width: "100px",
              header: "질문유형",
              field: "type",
              position: "center",
            },
            {
              width: "100px",
              header: "",
              field: "UpdateButton",
              position: "center",
              type: "Button",
              buttonLabel: "수정",
              backgroundColor: "rgb(28, 128, 211)",
            },
          ]}
          scrollable={true}
          scrollHeight={divboxHeight}
          className="QuestionTable"
          reorderColumns={true}
          reorderRows={true}
          reorderRowsChange={(e: any) => reorderRows(e)}
          onButtonClick={(row, id) => {
            if (id == "UpdateButton") {
              navigate("/QuestionDetailPage", {
                state: { p_id: row.p_id, state: "update" },
              });
            }
          }}
          onClick={(row) => {
            navigate("/QuestionDetailPage", {
              state: { p_id: row.p_id, state: "view" },
            });
          }}
        />
      </div>
      {alert && (
        <AlertComponent value={alert} setValue={setAlert} info="error">
          {alertMessage}
        </AlertComponent>
      )}
      {loading && <Loading />}
    </div>
  );
}
